import { render, staticRenderFns } from "./RootLoader.vue?vue&type=template&id=e6ad87b0&scoped=true"
import script from "./RootLoader.vue?vue&type=script&lang=ts"
export * from "./RootLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ad87b0",
  null
  
)

export default component.exports